import { historyHandler, mockMessageId } from '@/utils/historyHandler';
import { HISTORY_SHOW_TIME_MINUTES } from './../utils/constants';
import { UseLiveChatSDKApp } from '@/config/core';
import historyStore from '@/stores/history';

// 时间类型组件
const TIME_COMPONENTS = ['DateTime', 'AgentTime'];
const isTimeComponent = (type: string) => TIME_COMPONENTS.indexOf(type) !== -1;

let lastMessageTime = new Date().getTime();
let lastShowTime = new Date().getTime();
let beforeMessageId = '';

export default function formatHistoryMessages(messages: Array<any>) {
  const formatMessages = (messages || []).reduce((acc: Array<any>, cur) => {
    const sendTime = cur.send_time;
    const historyMessage = historyHandler(cur);

    if (!historyMessage) {
      return acc;
    }

    const outputInfoText = cur?.content?.message_extra?.output_info_text ?? '';
    historyMessage.messageDocQATipText = outputInfoText;

    if (UseLiveChatSDKApp.is() && (historyStore.hasShownLiveChatMsgIds[cur.message_id] || historyStore.hasShownLiveChatMsgSeqIds[cur?.content?.seq_id])) {
      return acc;
    }

    const lmt = new Date(lastMessageTime);
    lmt.setMinutes(lmt.getMinutes() + Number(HISTORY_SHOW_TIME_MINUTES));

    // 每隔五分钟添加一个时间
    if (
      historyMessage.type
      && !isTimeComponent(historyMessage.type)
      && lmt < new Date(lastShowTime)
    ) {
      acc.unshift({
        message_id: mockMessageId(),
        from: 'system',
        type: 'DateTime',
        data: { time: lastMessageTime },
      });

      lastShowTime = lastMessageTime;
    }

    // 显示时间的组件，更新上次显示时间
    if (isTimeComponent(historyMessage.type)) {
      lastShowTime = sendTime;
    }

    if (Array.isArray(historyMessage)) {
      lastShowTime = sendTime; // 目前若返回值为数组，则一定有时间
      acc.unshift(...historyMessage);
    } else {
      // 后端给的数据是倒序的
      acc.unshift(historyMessage);
    }

    lastMessageTime = sendTime;
    beforeMessageId = cur.message_id;

    return acc;
  }, []);

  return {
    messages: formatMessages,
    beforeMessageId,
  };
}
